/**
 * Callable and Auth errors to plain-English messages. The backend writes its
 * HttpsError messages for people, so those are shown as they come; transport
 * failures get our own wording. Never logs the payload (PII).
 */
export function errorCode(err) {
    const code = err?.code;
    return typeof code === 'string' ? code : '';
}
/** `functions/aborted` -> `aborted`. */
export function callableCode(err) {
    return errorCode(err).replace(/^functions\//, '');
}
export function isAborted(err) {
    return callableCode(err) === 'aborted';
}
export function isNotFound(err) {
    return callableCode(err) === 'not-found';
}
export function errorMessage(err, fallback = 'Something went wrong. Please try again.') {
    const code = callableCode(err);
    if (code === 'unavailable' || code === 'deadline-exceeded' || errorCode(err) === 'auth/network-request-failed') {
        return 'We could not reach the server. Check your connection and try again.';
    }
    if (code === 'internal' || code === 'unknown')
        return fallback;
    if (code === 'unauthenticated')
        return 'Your session has ended. Sign in again.';
    const message = err?.message;
    if (typeof message === 'string' && message.trim() && !/^(INTERNAL|internal)$/.test(message.trim())) {
        return message;
    }
    return fallback;
}
